import { ReactComponent as CameraIcon } from './camera.svg';

export const SvgIcons = {
  CameraIcon,
};
